import React from 'react'
import styled from 'styled-components'
import { ProgressBar, ProgressBarProps } from '@confer/lib'
import { BannerProps } from './Interfaces'

interface ClearheadProgressPanBannerProps {
  userProps: BannerProps
  progressBarProps: ProgressBarProps
}

/**
 * Clearhead-only left banner: image pans slowly with survey progress.
 * 0% progress = left side of image, 100% progress = right side.
 * Uses object-position (no stretch) so image quality stays good.
 */
export const ClearheadProgressPanBanner = (props: ClearheadProgressPanBannerProps) => {
  const { contentPath, altText } = props.userProps
  const progress = props.progressBarProps.percentage

  return (
    <Container>
      <ImageWrapper progress={progress}>
        <img src={contentPath} alt={altText ?? 'Banner'} />
      </ImageWrapper>
      <ProgressBar {...props.progressBarProps} />
    </Container>
  )
}

const Container = styled.div`
  width: 30vw;
  height: 100%;
  position: relative;
  overflow: hidden;
`

const ImageWrapper = styled.div<{ progress: number }>`
  width: 100%;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: ${(props) => props.progress}% center;
    transition: object-position 0.5s ease;
  }
`
